module.exports = __webpack_public_path__ + "static/img/hkj2.168d458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/hkj2.jpg
// module id = W4bd
// module chunks = 0